import Navigation from "@/components/numa/Navigation";
import Hero from "@/components/numa/Hero";
import ProductSystem from "@/components/numa/ProductSystem";
import Ingredients from "@/components/numa/Ingredients";
import DeliverySystem from "@/components/numa/DeliverySystem";
import Philosophy from "@/components/numa/Philosophy";
import Waitlist from "@/components/numa/Waitlist";
import Footer from "@/components/numa/Footer";

export default function NumaLanding() {
  return (
    <main
      data-testid="numa-landing"
      className="min-h-screen bg-[#F9F9F6] text-[#152219] font-body antialiased"
    >
      <Navigation />
      <Hero />
      <ProductSystem />
      <Ingredients />
      <DeliverySystem />
      <Philosophy />
      <Waitlist />
      <Footer />
    </main>
  );
}
